import { format, isValid } from 'date-fns';

import { useGetUser } from 'entities/user/api';

import type { UserType } from 'types';

export const useFormatUserDate = () => {
  const { data: userData } = useGetUser();
  const { dateFormat } = userData as UserType;

  return (date: string | undefined | null) => {
    const isValidDate =
      typeof date === 'string' ? isValid(new Date(date)) : false;

    return isValidDate ? format(new Date(date as string), dateFormat) : date;
  };
};

export const useFormatUserOnlyDate = () => {
  const format = useFormatUserDate();
  return (date?: string | undefined | null) => format(date)?.split(' ')[0];
};
